export default __webpack_public_path__ + "locales/fi/Payments.json?hash=0034d8cf941ba80fa6d7b7d1f7478069";